module.exports = __webpack_public_path__ + "static/media/1@2x.a2c02a9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/1@2x.png
// module id = 360
// module chunks = 0